import { COPYABLE_KINDS } from '../scheduleClipboard/pasteSchedule';

const DAY_NAMES = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

/** 지점 스케줄에서 끌어 옮길 수 있는 일정. 그룹레슨은 조회 전용이라 제외한다. */
export const isMovableEvent = event =>
  COPYABLE_KINDS.includes(event?.courseClassType) && event.courseClassType !== 'GROUP_LESSON';

/** 'YYYY-MM-DD' 의 요일 enum. Date 문자열 파싱은 시간대에 따라 하루 어긋나 직접 계산한다. */
export const dayOfWeekName = dateString => {
  const [year, month, day] = String(dateString).split('-').map(Number);
  return DAY_NAMES[new Date(year, month - 1, day).getDay()];
};

/**
 * 놓은 칸(slotMinutes = 칸 시작 시각, 자정부터 분)이 원래 시작 시각이 속한 칸과 같은지.
 * 구간 크기는 선택 단위(unitMinutes, 5분~1시간). 분이 있는 카드(14:10)도 제 칸(14시)에 놓으면 시간 변경이 아니다.
 */
export const isSameStart = (event, slotMinutes, unitMinutes = 60) =>
  Math.floor((event.startHour * 60 + event.startMinute) / unitMinutes) * unitMinutes === slotMinutes;

/** 일정 변경 푸시 문구 — "{강사명} 강사님 {수업명} 수업이 {M월 D일 HH:mm}으로 변경되었습니다." */
export const scheduleChangePush = ({ trainerName, className, date, startTime }) => ({
  title: '수업 일정 변경',
  content: `${trainerName ? `${trainerName} 강사님 ` : ''}${className || ''} 수업이 ${monthDayLabel(date)} ${String(
    startTime || '',
  ).slice(0, 5)}으로 변경되었습니다.`.trim(),
});

const monthDayLabel = dateString => {
  const [, month, day] = String(dateString).split('-').map(Number);
  return `${month}월 ${day}일`;
};
